export enum TLaunchTypeNames {
  'WEB' = 'WEB',
  'MOBILE' = 'MOBILE',
  'DESKTOP' = 'DESKTOP',
  'RUN_OUTSIDE_OF_PATIENT_CHART' = 'RUN_OUTSIDE_OF_PATIENT_CHART',
  'RUN_INSIDE_PATIENT_CHART' = 'RUN_INSIDE_PATIENT_CHART',
  'BACKEND_SERVICE' = 'BACKEND_SERVICE',
}

export enum TLaunchType {
  'STANDALONE' = 'STANDALONE',
  'EHR_EMBEDDED' = 'EHR_EMBEDDED',
  'BACKEND_SERVICE' = 'BACKEND_SERVICE',
}

export enum TAuthTypes {
  'PUBLIC' = 'PUBLIC',
  'CONFIDENTIAL' = 'CONFIDENTIAL',
}

export type TApplicationLaunchType = {
  id: string;
  name: TLaunchTypeNames;
  type: TLaunchType;
  auth_type: TAuthTypes;
  message?: any;
};

export enum ToAuthClientMechanism {
  JWKS = 'JWKS',
  CLIENTSECRET = 'CLIENTSECRET',
}

export type TApplicationScope = {
  id: string;
  name?: string;
  patient_population_r?: boolean;
  patient_population_w?: boolean;
  individual_patient_r?: boolean;
  individual_patient_w?: boolean;
  system_r?: boolean;
  system_w?: boolean;
  message?: any;
};

export type TProduction = {
  client_id?: string;
  client_secret?: string;
  smart_launch_url_production?: string;
  redirect_uri_production?: string;
};

export type TTechDetails = {
  application_launch_type: TApplicationLaunchType | null;
  auth_type: TApplicationLaunchType | null;
  has_patient_context?: boolean | null;
  has_encounter_context?: boolean | null;
  has_patient_individual?: boolean | null;
  has_patient_population?: boolean | null;
  token_introspection?: boolean | null;
  scopes: TApplicationScope[];
  //sandbox: TSandbox;
  production: TProduction;
  errors?: any;
  jwks?:any;
  oauthclienttype? :TAuthTypes;
  oauthclientmechanism? :ToAuthClientMechanism;
  client_secret? :string | null;
  tenants : string | null;
  scope_read_all : boolean;
  //tenant_list?: TTenant[] | null;
  production_toggle?:any;
  status?:TAppStatus;
  secret_expiry_date?: Date |null;
};

export type TTechDetailsResponse = {
  data?: TTechDetails | any;
};

export enum TAppStatus {
  CREATED = 'CREATED',
  REGISTERED = 'REGISTERED',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED',
}

export enum TFieldNames {
  ProductionSmartLaunchUrl = 'production.smart_launch_url_production',
  ProductionRedirectUri = 'production.redirect_uri_production',
  OAuthClientType = 'oauthclienttype',
  OAuthClientMechanism = 'oauthclientmechanism',
  Jwks = 'jwks',
  ApplicationLaunchType = 'application_launch_type',
  Scopes ="scopes",
  Has_Patient_Individual="has_patient_individual",
  Has_Patient_Population="has_patient_population",
  Token_Introspection ="token_introspection",
  Has_Patient_Context="has_patient_context",
}